import './jquery.debounce.js';

(function($) {
/**
 * define responsive nav component as its own jQuery extension
 */
$.fn.responsiveNav = function( options ) {

	options = $.extend({}, {
		wrapperSelector: '.site-wrapper',
		menuButtonSelector: '.menu-btn',
		menuOpenClass: 'menu-open',
		menuButtonActiveClass: 'active'
	}, options);

	var $this = $(this),
		menuOpen = false,
		$wrapper = $( options.wrapperSelector ),
		$menuButton = $( options.menuButtonSelector );

	var closeNav = function() {
		$wrapper.removeClass( options.menuOpenClass );
		$menuButton.removeClass( options.menuButtonActiveClass );
		$('html, body').css({'height':'','overflow':''});

		menuOpen = false;
	};

	var menuBtnFn = function() {
		$menuButton.bind( 'touchstart, click', function(event) {

			event.stopPropagation();
			event.preventDefault();

			if ( menuOpen ) {
				closeNav();
			}
			else{

				$wrapper.addClass( options.menuOpenClass );
				$(this).addClass( options.menuButtonActiveClass );

				$('html, body').css({'height':'100%','overflow':'hidden'});

				menuOpen = true;

			}
		}); //end button bind
	}; //end menuBtnFn

	menuBtnFn();

	$(window).resize( $.debounce(function() {
		if( !$menuButton.is(':visible') ) {
			//close mobile menu
			if ( menuOpen ) {
					closeNav();
			}
		}
	}, 150));

	return this;
};
})(jQuery);
